import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from 'react';
import swal from 'sweetalert';
import Select from 'react-select';
import { Modal, IconButton, Box, Tooltip, Backdrop, CircularProgress } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import 'react-quill/dist/quill.snow.css'; // Import the Quill editor's styles
import ReactQuill from "react-quill";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { getApiHeader } from 'utlis/commonfunctions';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
const SERVER_URL = process.env.REACT_APP_API_URL;

function DailyWorkPlan() {
    const [selectedWeek, setSelectedWeek] = useState({ start: '', end: '' });
    const [weekDays, setWeekDays] = useState([]);
    const [selectedDay, setSelectedDay] = useState("");  // To store the selected day
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchISLoading, setSearchIsLoading] = useState(false)
    const location = useLocation();
    const [selectedStores, setSelectedStores] = useState([]);
    const [storeOptions, setStoreOptions] = useState([]);
    const [activityNotes, setActivityNotes] = useState("");
    const [setLoad, setLoading] = useState(false)
    const navigate = useNavigate();

    const handleWeekChange = (e) => {
        const value = e.target.value;
   
        // Ensure that the value is not empty or invalid
        if (!value) {
            setWeekDays([]); // Clear weekDays if no valid week is selected
            setSelectedDay(null); // Reset selected day when no week is selected
            setSelectedWeek(null);
            return; // Exit if no week is selected
        }
    
        try {
            const weekRange = JSON.parse(value); // Parse the week data safely
            setSelectedWeek(weekRange); // Update selected week state
    
            const startDate = new Date(weekRange.start);

            const dayOfWeek = startDate.getDay();

            // If the start date is Sunday (0), adjust to Monday (1)
            if (dayOfWeek === 0) {
                startDate.setDate(startDate.getDate() + 1); // Move to the next day (Monday)
            }
            const days = [];
    
            // Generate weekdays based on the selected start of the week
            for (let i = 0; i < 5; i++) {
                const day = new Date(startDate);
                day.setDate(startDate.getDate() + i);
                days.push({
                    value: day.toISOString().split('T')[0], // Format as 'YYYY-MM-DD'
                    label: day.toLocaleString('default', { weekday: 'long' }) // Weekday name
                });
            }
    
            // Update weekDays state with the generated weekdays
            setWeekDays(days);
    
            // Reset selected day and ensure it's not disabled
            setSelectedDay(null); // Ensure that the day dropdown is reset when selecting a new week
        } catch (error) {
            console.error("Invalid JSON input", error);
        }
    };
    
    

    const handleNotesChange = (value) => {
        setActivityNotes(value); // Update activity notes state
    };


        const getWeekOptions = () => {
            const options = [];
            const currentDate = new Date();
        
            // Get the current day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
            const currentDay = currentDate.getDay();
            const daysUntilMonday = currentDay === 0 ? -6 : 1 - currentDay;  // Calculate days to the previous Monday
            currentDate.setDate(currentDate.getDate() + daysUntilMonday); // Set to the start of the current week (Monday)
        
            // Get the start of the current week (Monday)
            const startOfWeek = new Date(currentDate);
            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 4); // End of the week is 5 days after Monday (Friday)
        
            // Create the label for the current week (e.g., "Dec 4 - Dec 8")
            const weekLabel = `${startOfWeek.toLocaleString('default', { month: 'short' })} ${startOfWeek.getDate()} - ${endOfWeek.toLocaleString('default', { month: 'short' })} ${endOfWeek.getDate()}`;
            
            // Create the value for the current week (in ISO format)
            const weekRange = { start: startOfWeek.toISOString().split('T')[0], end: endOfWeek.toISOString().split('T')[0] };
        
            // Add the current week as the only option
            options.push(<option key={0} value={JSON.stringify(weekRange)}>{weekLabel}</option>);
        
            return options;
        };
        

    const [formData, setFormData] = useState({
        retailer_code: "",
        store_name: "",
        email: "",
        abn: "",
        state: "",
        city: "",
        postcode: "",
        street_name: "",
    });


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (
            formData.retailer_code === "" &&
            formData.store_name === "" &&
            formData.email === "" &&
            formData.abn === "" &&
            formData.state === "" &&
            formData.city === "" &&
            formData.postcode === "" &&
            formData.street_name === ""
        ) {
            toast.error("At least one input field must be filled");
            setLoading(false);
            return;
        } else if (formData.street_name && (formData.city === "" && formData.postcode === "")) {
            toast.error("Please enter post code or city name");
            setLoading(false);
            return;
        } else if (formData.state && (formData.city === "" && formData.postcode === "")) {
            toast.error("Please enter street name or post code");
            setLoading(false);
            return;
        }

        // Prepare the form data for API call
        const headers = await getApiHeader();
        const filteredFormData = Object.fromEntries(
            Object.entries(formData).filter(([key, value]) => value !== "")
        );

        try {
            const response = await axios.post(`${SERVER_URL}search-retailer-store`, filteredFormData, {
                headers: headers
            });

            const options = response.data.data.map((value) => ({
                label: value.retailer_company_name,
                value: value.retailer_id, // Assuming retailer_id is the value
            }));

            // Update store options to pass to the multi-select dropdown
            setStoreOptions(options);

            // Close modal after successful search
            setIsModalOpen(false);
            setLoading(false);

            if (options.length === 0) {
                toast.error("No shop details found.");
                // swal({
                //     title: "Error",
                //     text: 'No shop details found.',
                //     icon: "error",
                //     button: "Close",
                // });
            } else {
                toast.success("Shop details populated.");
                // swal({
                //     title: "Success",
                //     text: 'Shop details found.',
                //     icon: "success",
                //     button: "Close",
                // });
            }
        } catch (error) {
            console.log("Error fetching store data: ", error);
            setLoading(false);
        }
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // const handleDayChange = (selectedOption) => {
    //     setSelectedDay(selectedOption);
    // };

    const handleDayChange = (e) => {
        const selectedDayValue = e.target.value;
        setSelectedDay(weekDays.find(day => day.value === selectedDayValue)); // Find the day object
    };

    useEffect(() => {
        if (location.state) {

            const weekValue = {
                start: "2024-10-28",
                end: "2024-11-01"
            };

            handleWeekChange({ target: { value: JSON.stringify(weekValue) } });
        }
    }, [location.state]);

    // Modal toggle function
    const handleModalToggle = () => {
        setIsModalOpen(prevState => !prevState);
    };


    const handleSelectChange = (selectedOptions) => {
        setSelectedStores(selectedOptions);
    };

    const handleWorkSubmit = async (event) => {
        event.preventDefault();

        setLoading(true); // Start loading

        swal({
            title: 'Are you sure?',
            text: `Do you want to submit your daily work details ?`,
            icon: 'warning',
            buttons: {
                confirm: {
                    text: 'Yes, submit it',
                    className: 'btn-confirm',
                },
                cancel: {
                    text: 'No, cancel',
                    visible: true,
                    className: 'btn-cancel',
                },
            },
            iconColor: '#e31579', // Optionally change the icon color
        }).then(async (isConfirmed) => {
            if (!isConfirmed) {
                // If the user cancels, stop the loading indicator
                setLoading(false);
                return;
            }

            const workWeekStartDate = selectedWeek.start;
            const workWeekEndDate = selectedWeek.end;
            const selectedStoreIds = selectedStores.map((store) => store.value);
            const activityNotesFormatted = activityNotes;
            //const activityNotesFormatted = `<p>${activityNotes}</p>`;


            const data = {
                work_week_start_date: workWeekStartDate,
                work_week_end_date: workWeekEndDate,
                date: selectedDay ? selectedDay.value : "",
                activity_notes: activityNotesFormatted,
                stores: selectedStoreIds,
            };

            const headers = await getApiHeader();

            try {
                const response = await axios.post(`${SERVER_URL}work-plan/create-daily-work`, data, {
                    headers: headers
                });

                if (response.status === 200) {
                    const successMessage = response.data?.message;
                    // toast.success(successMessage);

                    swal({
                        title: "Success",
                        text: successMessage,
                        icon: "success",
                        button: "Close",
                    }).then(() => {
                       // navigate('/create_daily_work');
                       window.location.reload();
                    });
                    setLoading(false); // Stop loading after successful submission
                } else {
                    const errorMessage = response.data?.message || 'There was an issue with the submission.';
                    swal({
                        title: "Error",
                        text: errorMessage,
                        icon: "error",
                        button: "Close",
                    });
                    setLoading(false); // Stop loading after error
                }
            } catch (error) {
                let errorMessage = 'There was an issue with the submission.';

                if (error.response) {
                    errorMessage = error.response.data?.message || errorMessage;
                } else if (error.request) {
                    errorMessage = 'No response received from the server.';
                } else {
                    errorMessage = error.message || errorMessage;
                }

                console.error("Error creating work plan:", error);

                swal({
                    title: "Error",
                    text: errorMessage,
                    icon: "error",
                    button: "Close",
                });
                setLoading(false); // Stop loading in case of an error
            }
        });
    };


    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div className="container">
                {setLoad ? (
                    <Backdrop
                        open={true}
                        style={{
                            color: '#fff',
                            zIndex: 9999,
                        }}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>


                ) : (
                    <form className="workplanform col-lg-12" onSubmit={handleWorkSubmit}>
                        <h4>Update Daily Work</h4>
                        <div className="row">
                            {location.state ? (
                                <div className="work-details">
                                    <h4>{location.state.reviewer.name} Work Details</h4> <br></br>
                                </div>
                            ) : (
                                <div className="form-group col-lg-6">
                                    
                                    <label htmlFor="work-week" className="label">Select a Week:</label>
                                    <select id="work-week" name="work-week" className="select" onChange={handleWeekChange} value={selectedWeek ? JSON.stringify(selectedWeek) : ""}>
                                        <option value="">Please choose an option</option>
                                        {getWeekOptions()}
                                    </select>
                                    
                                </div>
                            )}

                        
                              <div className="form-group col-lg-6">
                               
                                <label htmlFor="work-day" className="label">Select a Day:</label>
                                <select 
                                    id="work-day" 
                                    name="work-day" 
                                    className="select"
                                    onChange={handleDayChange} 
                                    value={selectedDay ? selectedDay.value : ""} // Set selected day value
                                    disabled={!selectedWeek} // Disable the day selection if no week is selected
                                >
                                    <option value="">--Please choose a day--</option>
                                    {weekDays.map((day) => (
                                        <option key={day.value} value={day.value}>{day.label}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        

                        {/* Conditional rendering of the Work Plan Details section */}
                        {selectedDay && (
                            <div className="row align-items-center mb-3">
                                <label htmlFor="plan-details" className="label col-12">
                                    {location.state ? "Edit Work Plan Details:" : "Update my work details:"}
                                </label>

                                <div className="col-md-8">
                                    <Select
                                        isMulti
                                        options={storeOptions}  // storeOptions is populated with the API data
                                        value={selectedStores}  // selectedStores holds the current selected options
                                        onChange={handleSelectChange}
                                        placeholder="Search and add stores visited. "
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                borderRadius: "5px",
                                                padding: "5px",
                                            }),
                                            multiValue: (provided) => ({
                                                ...provided,
                                                backgroundColor: "#c11d6c",
                                                color: "white",
                                                padding: "1px",
                                            }),
                                            multiValueLabel: (provided) => ({
                                                ...provided,
                                                color: "white",
                                            }),
                                        }}
                                    />
                                </div>


                                <div className="col-md-1">
                                    <Tooltip title="Search details of stores" placement="bottom-end">
                                        <IconButton onClick={handleModalToggle} aria-label="search" style={{ marginLeft: '10px' }}>
                                            <SearchIcon sx={{ color: '#e20e75', transition: 'transform 0.2s' }} />
                                        </IconButton>
                                    </Tooltip>

                                </div>

                                <div className="col-md-12 mt-3">
                                    <ReactQuill
                                        value={activityNotes}
                                        onChange={handleNotesChange}
                                        placeholder="Please provide your daily work activities such as new shop visited, shops revisited and any other relevant tasks."
                                        modules={{
                                            toolbar: [
                                                [{ 'header': [1, 2, false] }],
                                                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                                ['link'],
                                                ['clean']
                                            ]
                                        }}
                                        style={{ borderColor: '#e20e75', borderRadius: '5px', height: '150px', marginBottom: "55px" }}
                                    />
                                </div>

                                {location.state && (
                                    <>
                                        <label htmlFor="plan-details" className="label col-12">Reporting Manager Comments</label>
                                        <div className="col-md-12 mt-3">
                                            <ReactQuill
                                                onChange={(value) => { }}
                                                placeholder="Provide your planned activities."
                                                modules={{
                                                    toolbar: [
                                                        [{ 'header': [1, 2, false] }],
                                                        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                                        ['link'],
                                                        ['clean']
                                                    ]
                                                }}
                                                style={{ borderColor: '#e20e75', borderRadius: '5px', height: '150px', marginBottom: "55px" }}
                                            />
                                        </div>
                                    </>
                                )}

                                {location.state ? (
                                    <div className="text-end">
                                        <button type="button" className="btn btn-success col-lg-4">Approve</button>
                                        <button type="button" className="btn btn-danger ms-2 col-lg-4">Reject</button>
                                    </div>
                                ) : (
                                    <button type="submit" className="submit-button">Submit</button>
                                )}
                            </div>
                        )}
                    </form>)}
            </div>

            <Modal open={isModalOpen} onClose={handleModalToggle}>

            <Box
                sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 600,
                bgcolor: 'background.paper',
                outline: 'none',
                //  boxShadow: 24,
                //  p: 4,
                borderRadius: 2,
                '@media (max-width: 950px)': {
                    maxHeight: '90%',
                    overflowY: 'auto',
                },
                '@media (max-width: 740px)': {
                    maxHeight: '90%',
                    overflowY: 'auto',
                },
                '@media (max-width: 480px)': {
                    width: '350px', // For very small screens (e.g., 350px)
                    maxHeight: '90%',
                    overflowY: 'auto',
                },
            }}
                >
                    
                  {!setLoad && (
                    <button
                        style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            background: 'transparent',
                            border: 'none',
                            fontSize: '24px',
                            cursor: 'pointer',
                            color: 'black',
                        }}
                        onClick={handleModalToggle} // This will close the modal
                    >
                        &times; {/* This is the "×" symbol */}
                    </button>
                     )}

                    {setLoad ? (
                     
                     <Backdrop
                        open={true}
                        sx={{
                            color: '#fff',
                            zIndex: 9999,
                            outline: 'none',
                            display: {
                                xs: 'none',  // Hide on mobile (less than 600px)
                                sm: 'flex',  // Show on small and above
                            },
                        }}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    

                    ) : (

                        <form action="" method="" onSubmit={handleSubmit}  autoComplete="off">
                            <div className="formbold-mb-5 formbold-pt-3" style={{ marginLeft: "10px", marginRight: "10px" }}>
                                <label className="formbold-form-label formbold-form-label-2">
                                </label>
                                <div className="flex flex-wrap formbold--mx-3">
                                    <div className="w-full sm:w-half formbold-px-3">
                                        <label htmlFor="store_name" className="formbold-form-label">
                                            Store Name
                                        </label>
                                        <div className="formbold-mb-5">
                                            <input
                                                type="text"
                                                name="store_name"
                                                id="store_name"
                                                placeholder="Enter Store Name"
                                                className="form-control"
                                                value={formData.store_name}
                                                onChange={handleChange}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>

                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                Email  Address
                                            </label>
                                            <input
                                                type="email"
                                                name="email"
                                                id="email"
                                                placeholder="Enter Email Address"
                                                className="form-control"
                                                value={formData.email}
                                                onChange={handleChange}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>

                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                Retailer ID
                                            </label>
                                            <input
                                                type="text"
                                                name="retailer_code"
                                                id="retailer_code"
                                                placeholder="Enter Retailer ID"
                                                className="form-control"
                                                value={formData.retailer_code}
                                                onChange={handleChange}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>
                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                ABN
                                            </label>
                                            <input
                                                type="text"
                                                name="abn"
                                                id="abn"
                                                placeholder="Enter ABN"
                                                className="form-control"
                                                value={formData.abn}
                                                onChange={handleChange}
                                                maxLength={12}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>

                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                City
                                            </label>
                                            <input
                                                type="text"
                                                name="city"
                                                id="city"
                                                placeholder="Enter City Name"
                                                className="form-control"
                                                value={formData.city}
                                                onChange={handleChange}
                                                autoComplete="new-password"
                                            />
                                        </div>
                                    </div>
                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                Post Code
                                            </label>
                                            <input
                                                type="text"
                                                name="postcode"
                                                id="postcode"
                                                placeholder="Enter Post Code"
                                                className="form-control"
                                                value={formData.postcode}
                                                onChange={handleChange}
                                                autoComplete="new-password"
                                            />
                                        </div>
                                    </div>
                                    <div className="w-full sm:w-half formbold-px-3">
                                        <div className="formbold-mb-5">
                                            <label htmlFor="store_name" className="formbold-form-label">
                                                Street Name
                                            </label>
                                            <input
                                                type="text"
                                                name="street_name"
                                                id="street_name"
                                                placeholder="Enter Street Name"
                                                className="form-control"
                                                value={formData.street_name}
                                                onChange={handleChange}
                                                autoComplete="new-password"
                                            />
                                        </div>
                                    </div>

                                    <div className="w-full sm:w-half formbold-px-3">
                                        <label htmlFor="store_name" className="formbold-form-label">
                                            State
                                        </label>
                                        <select
                                            className="form-control"
                                            name="state"
                                            id="state"
                                            value={formData.state}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select State</option>
                                            <option value="Act">ACT</option>
                                            <option value="NSW">NSW</option>
                                            <option value="NIT">NIT</option>
                                            <option value="QLD">QLD</option>
                                            <option value="SA">SA</option>
                                            <option value="TAS">TAS</option>
                                            <option value="VIC">VIC</option>
                                            <option value="WA">WA</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="search-store-buttons">
                                <button className="search-store-button" type="submit"><i class="fa fa-search"></i> Search</button>

                            </div>

                        </form>
                    )}
                </Box>
            </Modal>



        </DashboardLayout>
    );
}

export default DailyWorkPlan;
